import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { BasicInfoScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'

const RoomSizeField: React.FC<FieldProps<BasicInfoScreenValidationResult>> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  wrapperClassName = 'grid-item margin-top-l palm-one-whole lap-one-half desk-one-half lap-padding-left-m desk-padding-left-m',
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='room-size'
        propertyName='roomSize'
        placeholder=''
        label={<span>{t('wizard.screen.basicInfo.roomSizeField', 'Living space')}</span>}
        value={insertionData.roomSize}
        maxLength={12}
        type='text'
        affixRight='unit'
        unitRight='sqm'
        errors={validationMessages?.roomSize ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default RoomSizeField
